import React from "react";
import { Bug } from "lucide-react";

interface DebugOverlayProps {
  debugMode: boolean;
  workoutId: string | undefined;
  isDirty: boolean;
  exerciseCount: number;
}

export const DebugOverlay: React.FC<DebugOverlayProps> = ({ debugMode, workoutId, isDirty, exerciseCount }) => {
  if (!debugMode) return null;
  return (
    <div className="fixed top-4 right-4 bg-yellow-100 dark:bg-yellow-900/30 p-2 rounded text-xs border border-yellow-300 dark:border-yellow-700 z-50">
      <div className="font-mono">Debug Mode: ON</div>
      <div>Workout ID: {workoutId}</div>
      <div>Dirty: {isDirty ? "Yes" : "No"}</div>
      <div>Exercises: {exerciseCount}</div>
      <div className="mt-1 text-amber-600">
        Click <Bug className="h-3 w-3 inline" /> icons for exercise details
      </div>
    </div>
  );
};
